<template>
  <div
    v-if="filtrosOptions && filtrosOptions.length > 0"
    :class="direction == 'v' ? 'flex flex-col gap-4 p-2 filters-inputs' : ' grid  md:grid-cols-1 lg:grid-cols-5 gap-2 '"
    >
    <!-- :class="filtro.type == 'date-range'?'col-span-2' : 'col-span-1'" -->
    <div
    v-for="(filtro, index) in filtrosOptions.filter( item => !item.hidden)"
    :key="index"
    class="relative"
     >
      <template v-if="filtro.type == 'select'">
        <SelectAvanced
          v-if="filtro.searchable"
          :id="filtro.name"
          v-model="filtro.value"
          :label="filtro.label"
          :options="filtro.list"
          :url-search="filtro.urlSearch"
          :action="filtro.action"
          :map-options="getMapOptions(filtro)"
          :option-text="filtro.optionText"
          :params="filtro.params"
          :option-value="filtro.optionValue"
          :disabled="filtro.disabled"
          :searchable="true"
          :clear="filtro.clear"
          :group-options="getGroupOptions(filtro)"
          @update:model-value="onBuscar()"
        />
        <SelectDefault
          v-else
          :id="filtro.name"
          v-model="filtro.value"
          :label="filtro.label"
          size="small"   
          :clear="filtro.clear ?? true"
          :clear-event="() => clearValue(index)"
          :options="filtro.list"
          :url-search="filtro.urlSearch"
          :action="filtro.action"
          :map-options="filtro.mapOptions"
          :option-text="filtro.optionText"
          :params="filtro.params"
          :option-value="filtro.optionValue"
          :disabled="filtro.disabled"
          @change="onBuscar()"

        />
      </template>
      <template v-else-if="filtro.type == 'search'">
        <SelectSearch
          :id="filtro.name"
          v-model:search="filtro.search"
          v-model:value="filtro.value"
          :label="filtro.label"
          size="small"
          :clear="true"
          :minlength="filtro.minlength"
          :clear-event="() => clearValue(index)"
          :list="!filtro.urlSearch ? filtro.list : undefined"
          :initial-data="!filtro.urlSearch && Array.isArray(filtro.list)"
          :options="{
            urlSearch: filtro.urlSearch,
            action: filtro.action,
            ruteParams: filtro.ruteParams,
            mapOptions: filtro.mapOptions,
            optionText: filtro.optionText,
            optionValue: filtro.optionValue,
            params: filtro.params,
            fieldFilter: !filtro.urlSearch
              ? {
                  name: filtro.optionText || 'optionText',
                  mapOptions: (item: any) => item[filtro.optionText || 'optionText']
                }
              : undefined
          }"
          @cambiar-valor="($event:any) => {
            setValueSearch(index, $event)
            onBuscar()
          }"
          @update:search="(val: string) => checkEmptyValue(val, index)"
        />
      </template>
      <template v-else-if="filtro.type == 'date'">
        <DatePickerDefault
        :id="filtro.name"
        v-model="filtro.value"
        size="small"
        :clear-event="() => clearValue(index)"
        :label="filtro.label"
        :clear="true"
          @update:model-value="($event: string) => {
            setValue(index, $event)
            checkEmptyValue($event, index)
            if ($event) onBuscar()
          }" />
      </template>
      <template v-else-if="filtro.type == 'date-range'">
        <DatePickerDefault
          :id="filtro.name"
          v-model="filtro.value"
          size="small"
          :clear-event="() => clearValue(index)"
          :label="filtro.label"
          :clear="true"
          range
          @update:model-value="($event: string) => {
            checkEmptyValue($event, index)
            if($event) onBuscar()
          }"  />
      </template>
      <template v-else-if="filtro.type == 'patient'">
        <PatientListDefault
          :id="filtro.name"
          v-model:search="filtro.search"
          size="small"
          :minlength="filtro.minlength"
          :on-before-change="(callback: Function, valor: string) => { setValue(index, valor as string) }"
          :is-alter="false"
          :label="filtro.label"  :clear="true"
          :clear-event="() => clearValue(index)"
          @update:search="(val: string) => checkEmptyValue(val, index)"></PatientListDefault>
      </template>
      <template v-else>
        <InputDefault
          :id="filtro.name"
          v-model="filtro.value"
          size="small"
          :label="filtro.label"  :clear="true"
          :clear-event="() => clearValue(index)"
          :type="filtro.type"
          @keypress.enter="onBuscar()"
          @update:model-value="(val) => checkEmptyValue(val, index)" />
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import type {
  IFiltersOptions,
  IFiltersSelectOption,
  ISelectOption
} from '@/modules/Core/interfaces'
const props = defineProps({
  filtros: {
    type: Array<IFiltersOptions>,
    default: []
  },
  onBuscar: {
    type: Function,
    default: () => { }
  },
  direction: {
    type: String,
    default: "v"
  }
})
const { onBuscar, filtros, direction } = props
const filtrosOptions = computed(() => filtros?.filter(item => !item.hidden))
const isClearing = ref(false)

const getMapOptions = (filtro: IFiltersOptions) =>
  filtro.mapOptions as ((item: object) => ISelectOption) | undefined

const getGroupOptions = (filtro: IFiltersOptions) =>
  filtro.groupOptions as ((item: object) => string | null | undefined) | undefined

function setValueSearch(index: number, option: IFiltersSelectOption) {
  if (!filtrosOptions.value) return
  const filtro = filtrosOptions.value[index]
  if (!filtro.optionValue || !filtro.optionText) return
  filtrosOptions.value[index].value = filtro.mapOptions ? option.optionValue : option[filtro.optionValue]
  filtrosOptions.value[index].search = filtro.mapOptions ? option.optionText : option[filtro.optionText]
}
function setValue(index: number, valor: string) {
  if (filtrosOptions.value && filtrosOptions.value[index]) {
    filtrosOptions.value[index].value = valor
    onBuscar()
  }
}
function clearValue(index: number) {
  if (!filtrosOptions.value) return
  isClearing.value = true
  filtrosOptions.value[index].value = null
  filtrosOptions.value[index].search = null
  onBuscar()
  isClearing.value = false
}

function checkEmptyValue(value: string, index: number) {
  if (isClearing.value) return // Evitar doble llamada durante limpieza
  if (value === null || value === undefined || value === '') {
    if (filtrosOptions.value && filtrosOptions.value[index]) {
      if (filtrosOptions.value[index].value !== null && filtrosOptions.value[index].value !== undefined) {
        filtrosOptions.value[index].value = null
        if (filtrosOptions.value[index].search !== undefined) {
          filtrosOptions.value[index].search = null
        }
        onBuscar()
      }
    }
  }
}
</script>
